<template>
  <div class="pt-12 md:pb-20 lg:pb-20 pb-10">
    <div class="md:w-4/5 lg:w-4/5 w-full px-6 md:px-0 lg:px-0 mx-auto">
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold md:pb-6 lg:pb-8 pb-2"
      >
        Legal Documents
      </p>
      <div
        class="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-2 md:gap-12 lg:gap-12 gap-2 md:pt-10 lg:pt-10 pt-2"
      >
        <div
          class="flex justify-between md:p-6 lg:p-6 p-2 rounded-lg shadow-lg cursor-pointer"
          @click="downloadDoc('one')"
        >
          <p class="team-mbr-name text-black">Certificate of Incorporation</p>
          <!-- <img
            src="../../../assets/images/download.png"
            alt="Download"
            class="h-4 w-4"
          /> -->
          <feather-icon icon="EyeIcon" class="text-gray"></feather-icon>
        </div>

        <div
          class="flex justify-between md:p-6 lg:p-6 p-2 rounded-lg shadow-lg cursor-pointer"
          @click="downloadDocs('two')"
        >
          <p class="team-mbr-name text-black">80G Certificate</p>
          <!-- <img
            src="../../../assets/images/download.png"
            alt="Download"
            class="h-4 w-4"
          /> -->
          <feather-icon icon="EyeIcon" class="text-gray"></feather-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    downloadDoc(val) {
      const docOne = `${process.env.VUE_APP_IMAGE_URL}/caregiversaathi/CERTIFICATE%20OF%20INCORPORATION%20(1).PDF`;
      // const docTwo = "src/assets/images/caregiver/TEWE_1694508863021.pdf";
      window.open(docOne, "_blank");
      // const downloadLink = document.createElement("a");
      // if (val == "one") {
      // downloadLink.href = docOne;
      // downloadLink.download = "bannerImage-yDNFP4PmM3FCcktqpzxoD-1695289243";
      // } else {
      //   downloadLink.href = docTwo;
      //   downloadLink.download("TEWE_1694508863021.pdf");
      // }
      // downloadLink.click();
    },
    downloadDocs(val) {
      const docOnee = `${process.env.VUE_APP_IMAGE_URL}/caregiversaathi/80g%20-%202025%20-%20new.pdf`;
      window.open(docOnee, "_blank");
    },
  },
};
</script>
